import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import acceptInviteImage from "../Media/accept-invite-illustration.png";
import acceptedInviteImage from "../Media/accepted-invite-illustration.png";
import healthcareOrgExploreHealthImage from "../Media/HealthEx-explore-illustration.png";
import researcherExploreHealthImage from "../Media/what-is-healthex-1.png";
import { mobilePageMaxWidth } from "./HXMobilePage.styles";
import { FlexColumn, FlexColumnDiv } from "./common.styles";
import { fontWeights } from "healthex-common/weights";
import { HXDialogActions, HXDialogContent, HXDialogHeader } from "./HXDialog";
import { HXMobilePageTitleText } from "./HXMobilePage.styles";
export const appFonts = [
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Noto Sans",
    "Helvetica",
    "Arial",
    "sans-serif",
    "Apple Color Emoji",
    "Segoe UI Emoji",
];
export const AppWrapper = styled.div `
    position: relative;
    font-family: ${appFonts.join(",")};
    font-size: ${fontSizes.STANDARD};
    line-height: 1.5;
    color: ${colors.black};
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    min-height: 100%;
    align-items: center;
    box-sizing: border-box;
`;
export const App = styled(FlexColumnDiv) `
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1 0 0;
`;
export const MobileAppWrapper = styled(AppWrapper) `
    height: ${(props) => { var _a; return (_a = props.height) !== null && _a !== void 0 ? _a : "auto"; }};
    background: ${(props) => props.showLoginGradient ? "linear-gradient(180deg, #FFE09A -52.59%, #FAFAFA 45.84%)" : colors.white_background};
`;
export const MobileApp = styled(App) `
    max-width: ${mobilePageMaxWidth}px;
`;
export const Content = styled.div `
    flex-grow: 1;
    background-color: ${colors.white_background};
    height: 100%;
`;
export const AcceptInviteImage = styled.div `
    background-image: url(${acceptInviteImage});
    background-size: cover;
    background-repeat: no-repeat;
    margin: auto;
    margin-top: -30px;
    width: 145px;
    height: 110px;
`;
export const AcceptedInviteImage = styled.div `
    background-image: url(${acceptedInviteImage});
    background-size: cover;
    background-repeat: no-repeat;
    margin: auto;
    margin-top: -15px;
    width: 145px;
    height: 110px;
`;
const BaseExploreHealthImageCSS = css `
    background-size: cover;
    background-repeat: no-repeat;
    margin: auto;
    margin-top: -15px;
    width: 140px;
    height: 155px;
`;
export const HealthcareOrgExploreHealthImage = styled.div `
    background-image: url(${healthcareOrgExploreHealthImage});
    ${BaseExploreHealthImageCSS}
`;
export const ResearcherExploreHealthImage = styled.div `
    background-image: url(${researcherExploreHealthImage});
    ${BaseExploreHealthImageCSS}
`;
export const DesktopNotEnoughSpaceContainer = styled(FlexColumnDiv) `
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 0 38px;
    max-width: ${mobilePageMaxWidth}px;
    font-family: ${appFonts.join(",")};
`;
export const DesktopNotEnoughSpaceContent = styled(FlexColumnDiv) `
    align-items: center;
    gap: 40px;
`;
export const DesktopNotEnoughSpaceTitle = styled(HXMobilePageTitleText) `
    color: ${colors.black_lighter};
    text-align: center;
    white-space: pre-wrap;
`;
export const DesktopNotEnoughSpaceImage = styled.img `
    max-width: 100%;
`;
export const DesktopNotEnoughSpaceText = styled.div `
    color: ${colors.black_lighter};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    text-align: center;
    letter-spacing: 0.4px;
`;
export const EducationDialogContent = styled(HXDialogContent) `
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 40px;
    letter-spacing: 0.15px;
`;
export const EducationDialogActions = styled(HXDialogActions) `
    justify-content: center;
`;
export const EducationDialogHeader = styled(HXDialogHeader) `
    flex-direction: column-reverse;
    gap: 0px;

    &:nth-child(1) {
        align-items: center;
    }

    &:nth-child(2) {
        align-items: right;
    }
`;
export const DesktopAppWrapper = styled(AppWrapper) `
    height: 100%;
`;
export const DesktopApp = styled(App) `
    flex: unset;
    height: 100%;
`;
export const DesktopContentWrapper = styled(FlexColumn) `
    height: 100%;
    align-self: stretch;
    overflow-y: auto;
`;
export const DesktopContent = styled(Content) `
    flex-grow: unset;
    height: unset;
    flex: 1 0 0;
    align-self: stretch;
`;
